export const serverIp = '15.235.133.208:7007';

export const socialLinks = {
  discord: 'https://discord.gg/gtawestcounty',
  tiktok: 'https://www.tiktok.com/@gta.westcounty',
};

export const content = {
  id: {
    nav: [
      { label: 'Beranda', target: 'home' },
      { label: 'Status', target: 'status' },
      { label: 'Panduan', target: 'connect' },
      { label: 'Donasi', target: 'store' },
    ],
    common: {
      login: 'Masuk',
      register: 'Daftar',
      registerUcp: 'Masuk UCP',
      copied: 'IP disalin',
      serverIp: 'Alamat Server',
      rules: 'Peraturan',
      language: 'Bahasa',
      chooseLanguage: 'Pilih bahasa',
    },
    loader: {
      title: 'GTA:WestCounty',
      text: 'tunggu sebentar...',
    },
    hero: {
      eyebrow: 'GTA:WestCounty',
      title: 'Mulai cerita karaktermu di GTA:WestCounty.',
      description:
        'Server roleplay SA-MP/open.mp untuk kamu yang ingin main santai tapi tetap punya arah. Kamu bisa bikin karakter, cari pekerjaan, ketemu pemain lain, ikut kegiatan kota, dan pelan-pelan bangun cerita sesuai jalan yang kamu pilih.',
      primary: 'Masuk UCP',
      secondary: 'Panduan Masuk',
      status: 'Status Server',
      online: 'ONLINE',
      cardTitle: 'GTA:WestCounty',
      cardText: 'Portal resmi untuk akses UCP, informasi server, panduan pemain, dan layanan komunitas.',
      onlineMeta: 'Roleplay aktif',
      runtimeMeta: '24/7',
    },
    status: {
      label: 'Status Server',
      title: 'Pantau kondisi server sebelum masuk bermain.',
      text: 'Di bagian ini kamu bisa melihat status server, jumlah pemain online, dan total akun terdaftar secara langsung.',
      stats: [
        { value: '24/7', label: 'Server Aktif', detail: 'Server tersedia untuk aktivitas roleplay harian.' },
        { value: '0', label: 'Player Online', detail: 'Jumlah pemain yang sedang berada di server.' },
        { value: '0+', label: 'Player Terdaftar', detail: 'Total akun UCP yang sudah melakukan pendaftaran.' },
      ],
    },
    connect: {
      label: 'Panduan Masuk',
      title: 'Mau mulai bermain di GTA:WestCounty?',
      text: 'Siapkan akunmu dulu, buat karakter, lalu ikuti beberapa langkah berikut agar bisa masuk ke server tanpa bingung.',
      steps: [
        { number: '01', title: 'Masuk Akun UCP', text: 'Gunakan akun UCP yang sudah tersedia untuk mengakses layanan pemain dan data karakter.' },
        { number: '02', title: 'Baca Informasi Discord', text: 'Masuk ke Discord untuk melihat pengumuman, aturan, dan panduan roleplay.' },
        { number: '03', title: 'Hubungkan ke Server', text: 'Tambahkan alamat server di SA-MP/open.mp, lalu mulai bermain sesuai alur karakter.' },
      ],
    },
    store: {
      label: 'Dukungan Server',
      title: 'Dukung pengembangan server secara resmi.',
      text: 'Donasi digunakan untuk membantu operasional dan pengembangan server. Benefit tetap diarahkan agar tidak merusak keseimbangan roleplay.',
      primary: 'Buka Donasi',
      secondary: 'Baca Rules',
    },
    community: {
      label: 'Komunitas',
      title: 'Ruang berkumpul untuk pemain GTA:WestCounty.',
      items: [
        { title: 'Informasi Terpusat', text: 'Pengumuman, update, dan panduan pemain dikumpulkan dalam satu tempat.' },
        { title: 'Lingkungan Tertib', text: 'Komunitas diarahkan untuk menjaga suasana bermain yang nyaman dan saling menghargai.' },
        { title: 'Terhubung dengan Staff', text: 'Pemain dapat mengikuti informasi resmi, bantuan, serta proses pendaftaran melalui kanal komunitas.' },
      ],
    },
    faq: {
      label: 'FAQ',
      title: 'Pertanyaan yang sering ditanyakan.',
      items: [
        { question: 'Apa fokus utama GTA:WestCounty?', answer: 'GTA:WestCounty berfokus pada roleplay kehidupan kota dengan sistem yang mudah dipahami, komunitas aktif, dan suasana bermain yang tertata.' },
        { question: 'Apakah wajib daftar UCP?', answer: 'Ya. UCP digunakan untuk mengelola akun, akses login, serta data awal pemain sebelum masuk ke server.' },
        { question: 'Apakah website ini bisa disambungkan ke backend?', answer: 'Bisa. Struktur project sudah dipisah sehingga mudah dihubungkan ke API status server, login, register, dan database.' },
      ],
    },
    footer: {
      text: '© 2026 GTA:WestCounty.',
      socialTitle: 'Ikuti GTA:WestCounty',
      socialText: 'Dapatkan update server, event, dan informasi komunitas melalui kanal resmi.',
      discord: 'Discord',
      discordText: 'Pengumuman, bantuan, dan komunitas pemain.',
      tiktok: 'TikTok GTA:WestCounty',
      tiktokText: 'Highlight, trailer, dan konten komunitas.',
    },
  },
  en: {
    nav: [
      { label: 'Home', target: 'home' },
      { label: 'Status', target: 'status' },
      { label: 'Guide', target: 'connect' },
      { label: 'Support', target: 'store' },
    ],
    common: {
      login: 'Login',
      register: 'Register',
      registerUcp: 'Login UCP',
      copied: 'IP copied',
      serverIp: 'Server Address',
      rules: 'Rules',
      language: 'Language',
      chooseLanguage: 'Choose language',
    },
    loader: {
      title: 'GTA:WestCounty',
      text: 'Waiting a moment...',
    },
    hero: {
      eyebrow: 'GTA:WestCounty',
      title: 'Start your story in GTA:WestCounty.',
      description:
        'A SA-MP/open.mp roleplay server for players who want a relaxed but still directed roleplay experience. Create your character, find a job, meet other players, join city activities, and build your story step by step.',
      primary: 'Login UCP',
      secondary: 'Join Guide',
      status: 'Server Status',
      online: 'ONLINE',
      cardTitle: 'GTA:WestCounty',
      cardText: 'Official portal for UCP access, server information, player guides, and community services.',
      onlineMeta: 'Active roleplay',
      runtimeMeta: '24/7',
    },
    status: {
      label: 'Server Status',
      title: 'Check the server condition before joining.',
      text: 'In this section you can see the server status, number of online players, and total registered accounts directly.',
      stats: [
        { value: '24/7', label: 'Server Active', detail: 'Available for daily roleplay activities.' },
        { value: '0', label: 'Online Players', detail: 'Players currently connected to the server.' },
        { value: '0+', label: 'Registered Players', detail: 'Total UCP accounts that have completed registration.' },
      ],
    },
    connect: {
      label: 'Join Guide',
      title: 'Ready to play GTA:WestCounty?',
      text: 'Set up your account, create your character, and follow the steps below to join the server smoothly.',
      steps: [
        { number: '01', title: 'Sign in to UCP', text: 'Use an existing UCP account to access player services and character data.' },
        { number: '02', title: 'Read Discord Information', text: 'Join Discord to view announcements, rules, and roleplay guidelines.' },
        { number: '03', title: 'Connect to the Server', text: 'Add the server address in SA-MP/open.mp, then start playing based on your character flow.' },
      ],
    },
    store: {
      label: 'Server Support',
      title: 'Support server development officially.',
      text: 'Donations help cover operations and development. Benefits should remain balanced and aligned with roleplay rules.',
      primary: 'Open Support',
      secondary: 'Read Rules',
    },
    community: {
      label: 'Community',
      title: 'A place for GTA:WestCounty players to connect.',
      items: [
        { title: 'Central Information', text: 'Announcements, updates, and player guides are gathered in one place.' },
        { title: 'Respectful Environment', text: 'The community is directed to maintain a comfortable and respectful gameplay atmosphere.' },
        { title: 'Connected with Staff', text: 'Players can follow official information, support, and registration processes through community channels.' },
      ],
    },
    faq: {
      label: 'FAQ',
      title: 'Frequently asked questions.',
      items: [
        { question: 'What is GTA:WestCounty focused on?', answer: 'GTA:WestCounty focuses on city-life roleplay with easy-to-understand systems, an active community, and an organized gameplay atmosphere.' },
        { question: 'Is UCP access required?', answer: 'Yes. UCP is used to manage accounts, login access, and initial player data before entering the server.' },
        { question: 'Can this website be connected to a backend?', answer: 'Yes. The project structure is separated so it can be connected to server status, login, registration, and database APIs.' },
      ],
    },
    footer: {
      text: '© 2026 GTA:WestCounty.',
      socialTitle: 'Follow GTA:WestCounty',
      socialText: 'Get server updates, events, and community information through official channels.',
      discord: 'Official Discord',
      discordText: 'Announcements, support, and player community.',
      tiktok: 'GTA:WestCounty TikTok',
      tiktokText: 'Highlights, trailers, and community content.',
    },
  },
};
